import * as X from "react";
import Br, { forwardRef as At, useContext as Gr, useState as $t } from "react";
import { Trigger as kt } from "@illa-design/trigger";
import { Typography as It, Heading as Dt } from "@illa-design/typography";
import { css as ur } from "@emotion/react";
import { globalColor as Nr, illaPrefix as Ar } from "@illa-design/theme";
import { ConfigProviderContext as Ft, def as Mt } from "@illa-design/config-provider";
import { Link as jt } from "@illa-design/link";
var ar = { exports: {} }, me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $r;
function Vt() {
  if ($r)
    return me;
  $r = 1;
  var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(l, p, h) {
    var d, y = {}, N = null, A = null;
    h !== void 0 && (N = "" + h), p.key !== void 0 && (N = "" + p.key), p.ref !== void 0 && (A = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: N, ref: A, props: y, _owner: o.current };
  }
  return me.Fragment = n, me.jsx = u, me.jsxs = u, me;
}
var ye = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kr;
function Lt() {
  return kr || (kr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), N = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), C = Symbol.iterator, E = "@@iterator";
    function D(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = C && t[C] || t[E];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          f[m - 1] = arguments[m];
        $("error", t, f);
      }
    }
    function $(t, s, f) {
      {
        var m = S.ReactDebugCurrentFrame, R = m.getStackAddendum();
        R !== "" && (s += "%s", f = f.concat([R]));
        var k = f.map(function(_) {
          return String(_);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, k);
      }
    }
    var I = !1, c = !1, V = !1, P = !1, qe = !1, we;
    we = Symbol.for("react.module.reference");
    function Be(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || qe || t === o || t === h || t === d || P || t === A || I || c || V || typeof t == "object" && t !== null && (t.$$typeof === N || t.$$typeof === y || t.$$typeof === u || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === we || t.getModuleId !== void 0));
    }
    function Ge(t, s, f) {
      var m = t.displayName;
      if (m)
        return m;
      var R = s.displayName || s.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function xe(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return xe(s) + ".Consumer";
          case u:
            var f = t;
            return xe(f._context) + ".Provider";
          case p:
            return Ge(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : B(t.type) || "Memo";
          case N: {
            var R = t, k = R._payload, _ = R._init;
            try {
              return B(_(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Q = 0, Ce, Te, fe, Oe, ue, Pe, Ne;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function Je() {
      {
        if (Q === 0) {
          Ce = console.log, Te = console.info, fe = console.warn, Oe = console.error, ue = console.group, Pe = console.groupCollapsed, Ne = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Q++;
      }
    }
    function Ke() {
      {
        if (Q--, Q === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: Ce
            }),
            info: H({}, t, {
              value: Te
            }),
            warn: H({}, t, {
              value: fe
            }),
            error: H({}, t, {
              value: Oe
            }),
            group: H({}, t, {
              value: ue
            }),
            groupCollapsed: H({}, t, {
              value: Pe
            }),
            groupEnd: H({}, t, {
              value: Ne
            })
          });
        }
        Q < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = S.ReactCurrentDispatcher, de;
    function re(t, s, f) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (R) {
            var m = R.stack.trim().match(/\n( *(at )?)/);
            de = m && m[1] || "";
          }
        return `
` + de + t;
      }
    }
    var pe = !1, te;
    {
      var He = typeof WeakMap == "function" ? WeakMap : Map;
      te = new He();
    }
    function v(t, s) {
      if (!t || pe)
        return "";
      {
        var f = te.get(t);
        if (f !== void 0)
          return f;
      }
      var m;
      pe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = le.current, le.current = null, Je();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Z) {
              m = Z;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (Z) {
              m = Z;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            m = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && m && typeof Z.stack == "string") {
          for (var b = Z.stack.split(`
`), W = m.stack.split(`
`), F = b.length - 1, M = W.length - 1; F >= 1 && M >= 0 && b[F] !== W[M]; )
            M--;
          for (; F >= 1 && M >= 0; F--, M--)
            if (b[F] !== W[M]) {
              if (F !== 1 || M !== 1)
                do
                  if (F--, M--, M < 0 || b[F] !== W[M]) {
                    var q = `
` + b[F].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && te.set(t, q), q;
                  }
                while (F >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        pe = !1, le.current = k, Ke(), Error.prepareStackTrace = R;
      }
      var oe = t ? t.displayName || t.name : "", Pr = oe ? re(oe) : "";
      return typeof t == "function" && te.set(t, Pr), Pr;
    }
    function ve(t, s, f) {
      return v(t, !1);
    }
    function ne(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ee(t, s, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ne(t));
      if (typeof t == "string")
        return re(t);
      switch (t) {
        case h:
          return re("Suspense");
        case d:
          return re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return ve(t.render);
          case y:
            return ee(t.type, s, f);
          case N: {
            var m = t, R = m._payload, k = m._init;
            try {
              return ee(k(R), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, yr = {}, Er = S.ReactDebugCurrentFrame;
    function ke(t) {
      if (t) {
        var s = t._owner, f = ee(t.type, t._source, s ? s.type : null);
        Er.setExtraStackFrame(f);
      } else
        Er.setExtraStackFrame(null);
    }
    function lt(t, s, f, m, R) {
      {
        var k = Function.call.bind($e);
        for (var _ in t)
          if (k(t, _)) {
            var b = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((m || "React class") + ": " + f + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[_](s, _, m, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              b = F;
            }
            b && !(b instanceof Error) && (ke(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", f, _, typeof b), ke(null)), b instanceof Error && !(b.message in yr) && (yr[b.message] = !0, ke(R), g("Failed %s type: %s", f, b.message), ke(null));
          }
      }
    }
    var dt = Array.isArray;
    function Ze(t) {
      return dt(t);
    }
    function pt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function vt(t) {
      try {
        return gr(t), !1;
      } catch {
        return !0;
      }
    }
    function gr(t) {
      return "" + t;
    }
    function br(t) {
      if (vt(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pt(t)), gr(t);
    }
    var he = S.ReactCurrentOwner, ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _r, Sr, Xe;
    Xe = {};
    function mt(t) {
      if ($e.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function yt(t) {
      if ($e.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Et(t, s) {
      if (typeof t.ref == "string" && he.current && s && he.current.stateNode !== s) {
        var f = B(he.current.type);
        Xe[f] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(he.current.type), t.ref), Xe[f] = !0);
      }
    }
    function gt(t, s) {
      {
        var f = function() {
          _r || (_r = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function bt(t, s) {
      {
        var f = function() {
          Sr || (Sr = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var _t = function(t, s, f, m, R, k, _) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: f,
        props: _,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function St(t, s, f, m, R) {
      {
        var k, _ = {}, b = null, W = null;
        f !== void 0 && (br(f), b = "" + f), yt(s) && (br(s.key), b = "" + s.key), mt(s) && (W = s.ref, Et(s, R));
        for (k in s)
          $e.call(s, k) && !ht.hasOwnProperty(k) && (_[k] = s[k]);
        if (t && t.defaultProps) {
          var F = t.defaultProps;
          for (k in F)
            _[k] === void 0 && (_[k] = F[k]);
        }
        if (b || W) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && gt(_, M), W && bt(_, M);
        }
        return _t(t, b, W, R, m, he.current, _);
      }
    }
    var Qe = S.ReactCurrentOwner, Rr = S.ReactDebugCurrentFrame;
    function ae(t) {
      if (t) {
        var s = t._owner, f = ee(t.type, t._source, s ? s.type : null);
        Rr.setExtraStackFrame(f);
      } else
        Rr.setExtraStackFrame(null);
    }
    var er;
    er = !1;
    function rr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function wr() {
      {
        if (Qe.current) {
          var t = B(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Rt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var xr = {};
    function wt(t) {
      {
        var s = wr();
        if (!s) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Cr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = wt(s);
        if (xr[f])
          return;
        xr[f] = !0;
        var m = "";
        t && t._owner && t._owner !== Qe.current && (m = " It was passed a child from " + B(t._owner.type) + "."), ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, m), ae(null);
      }
    }
    function Tr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (Ze(t))
          for (var f = 0; f < t.length; f++) {
            var m = t[f];
            rr(m) && Cr(m, s);
          }
        else if (rr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = D(t);
          if (typeof R == "function" && R !== t.entries)
            for (var k = R.call(t), _; !(_ = k.next()).done; )
              rr(_.value) && Cr(_.value, s);
        }
      }
    }
    function xt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          f = s.propTypes;
        else
          return;
        if (f) {
          var m = B(s);
          lt(f, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !er) {
          er = !0;
          var R = B(s);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ct(t) {
      {
        for (var s = Object.keys(t.props), f = 0; f < s.length; f++) {
          var m = s[f];
          if (m !== "children" && m !== "key") {
            ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ae(null);
            break;
          }
        }
        t.ref !== null && (ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function Or(t, s, f, m, R, k) {
      {
        var _ = Be(t);
        if (!_) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Rt(R);
          W ? b += W : b += wr();
          var F;
          t === null ? F = "null" : Ze(t) ? F = "array" : t !== void 0 && t.$$typeof === r ? (F = "<" + (B(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : F = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, b);
        }
        var M = St(t, s, f, R, k);
        if (M == null)
          return M;
        if (_) {
          var q = s.children;
          if (q !== void 0)
            if (m)
              if (Ze(q)) {
                for (var oe = 0; oe < q.length; oe++)
                  Tr(q[oe], t);
                Object.freeze && Object.freeze(q);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Tr(q, t);
        }
        return t === a ? Ct(M) : xt(M), M;
      }
    }
    function Tt(t, s, f) {
      return Or(t, s, f, !0);
    }
    function Ot(t, s, f) {
      return Or(t, s, f, !1);
    }
    var Pt = Ot, Nt = Tt;
    ye.Fragment = a, ye.jsx = Pt, ye.jsxs = Nt;
  }()), ye;
}
process.env.NODE_ENV === "production" ? ar.exports = Vt() : ar.exports = Lt();
var ge = ar.exports;
function Yt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Wt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Ut = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Wt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var u = Yt(o);
      try {
        u.insertRule(a, u.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", Ve = "-moz-", w = "-webkit-", lr = "comm", dr = "rule", pr = "decl", zt = "@import", Jr = "@keyframes", qt = "@layer", Bt = Math.abs, Ye = String.fromCharCode, Gt = Object.assign;
function Jt(e, r) {
  return L(e, 0) ^ 45 ? (((r << 2 ^ L(e, 0)) << 2 ^ L(e, 1)) << 2 ^ L(e, 2)) << 2 ^ L(e, 3) : 0;
}
function Kr(e) {
  return e.trim();
}
function Kt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function x(e, r, n) {
  return e.replace(r, n);
}
function or(e, r) {
  return e.indexOf(r);
}
function L(e, r) {
  return e.charCodeAt(r) | 0;
}
function be(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function vr(e) {
  return e.length;
}
function Ie(e, r) {
  return r.push(e), e;
}
function Ht(e, r) {
  return e.map(r).join("");
}
var We = 1, se = 1, Hr = 0, U = 0, j = 0, ce = "";
function Ue(e, r, n, a, o, i, u) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: We, column: se, length: u, return: "" };
}
function Ee(e, r) {
  return Gt(Ue("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Zt() {
  return j;
}
function Xt() {
  return j = U > 0 ? L(ce, --U) : 0, se--, j === 10 && (se = 1, We--), j;
}
function z() {
  return j = U < Hr ? L(ce, U++) : 0, se++, j === 10 && (se = 1, We++), j;
}
function K() {
  return L(ce, U);
}
function Fe() {
  return U;
}
function Re(e, r) {
  return be(ce, e, r);
}
function _e(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zr(e) {
  return We = se = 1, Hr = J(ce = e), U = 0, [];
}
function Xr(e) {
  return ce = "", e;
}
function Me(e) {
  return Kr(Re(U - 1, ir(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Qt(e) {
  for (; (j = K()) && j < 33; )
    z();
  return _e(e) > 2 || _e(j) > 3 ? "" : " ";
}
function en(e, r) {
  for (; --r && z() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Re(e, Fe() + (r < 6 && K() == 32 && z() == 32));
}
function ir(e) {
  for (; z(); )
    switch (j) {
      case e:
        return U;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ir(j);
        break;
      case 40:
        e === 41 && ir(e);
        break;
      case 92:
        z();
        break;
    }
  return U;
}
function rn(e, r) {
  for (; z() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && K() === 47)
      break;
  return "/*" + Re(r, U - 1) + "*" + Ye(e === 47 ? e : z());
}
function tn(e) {
  for (; !_e(K()); )
    z();
  return Re(e, U);
}
function nn(e) {
  return Xr(je("", null, null, null, [""], e = Zr(e), 0, [0], e));
}
function je(e, r, n, a, o, i, u, l, p) {
  for (var h = 0, d = 0, y = u, N = 0, A = 0, C = 0, E = 1, D = 1, S = 1, g = 0, $ = "", I = o, c = i, V = a, P = $; D; )
    switch (C = g, g = z()) {
      case 40:
        if (C != 108 && L(P, y - 1) == 58) {
          or(P += x(Me(g), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += Me(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += Qt(C);
        break;
      case 92:
        P += en(Fe() - 1, 7);
        continue;
      case 47:
        switch (K()) {
          case 42:
          case 47:
            Ie(an(rn(z(), Fe()), r, n), p);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * E:
        l[h++] = J(P) * S;
      case 125 * E:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            D = 0;
          case 59 + d:
            S == -1 && (P = x(P, /\f/g, "")), A > 0 && J(P) - y && Ie(A > 32 ? Dr(P + ";", a, n, y - 1) : Dr(x(P, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            P += ";";
          default:
            if (Ie(V = Ir(P, r, n, h, d, o, l, $, I = [], c = [], y), i), g === 123)
              if (d === 0)
                je(P, r, V, V, I, i, y, l, c);
              else
                switch (N === 99 && L(P, 3) === 110 ? 100 : N) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    je(e, V, V, a && Ie(Ir(e, V, V, 0, 0, o, l, $, o, I = [], y), c), o, c, y, l, a ? I : c);
                    break;
                  default:
                    je(P, V, V, V, [""], c, 0, l, c);
                }
        }
        h = d = A = 0, E = S = 1, $ = P = "", y = u;
        break;
      case 58:
        y = 1 + J(P), A = C;
      default:
        if (E < 1) {
          if (g == 123)
            --E;
          else if (g == 125 && E++ == 0 && Xt() == 125)
            continue;
        }
        switch (P += Ye(g), g * E) {
          case 38:
            S = d > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            l[h++] = (J(P) - 1) * S, S = 1;
            break;
          case 64:
            K() === 45 && (P += Me(z())), N = K(), d = y = J($ = P += tn(Fe())), g++;
            break;
          case 45:
            C === 45 && J(P) == 2 && (E = 0);
        }
    }
  return i;
}
function Ir(e, r, n, a, o, i, u, l, p, h, d) {
  for (var y = o - 1, N = o === 0 ? i : [""], A = vr(N), C = 0, E = 0, D = 0; C < a; ++C)
    for (var S = 0, g = be(e, y + 1, y = Bt(E = u[C])), $ = e; S < A; ++S)
      ($ = Kr(E > 0 ? N[S] + " " + g : x(g, /&\f/g, N[S]))) && (p[D++] = $);
  return Ue(e, r, n, o === 0 ? dr : l, p, h, d);
}
function an(e, r, n) {
  return Ue(e, r, n, lr, Ye(Zt()), be(e, 2, -2), 0);
}
function Dr(e, r, n, a) {
  return Ue(e, r, n, pr, be(e, 0, a), be(e, a + 1, -1), a);
}
function ie(e, r) {
  for (var n = "", a = vr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function on(e, r, n, a) {
  switch (e.type) {
    case qt:
      if (e.children.length)
        break;
    case zt:
    case pr:
      return e.return = e.return || e.value;
    case lr:
      return "";
    case Jr:
      return e.return = e.value + "{" + ie(e.children, a) + "}";
    case dr:
      e.value = e.props.join(",");
  }
  return J(n = ie(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function sn(e) {
  var r = vr(e);
  return function(n, a, o, i) {
    for (var u = "", l = 0; l < r; l++)
      u += e[l](n, a, o, i) || "";
    return u;
  };
}
function cn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function fn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var un = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = K(), o === 38 && i === 12 && (n[a] = 1), !_e(i); )
    z();
  return Re(r, U);
}, ln = function(r, n) {
  var a = -1, o = 44;
  do
    switch (_e(o)) {
      case 0:
        o === 38 && K() === 12 && (n[a] = 1), r[a] += un(U - 1, n, a);
        break;
      case 2:
        r[a] += Me(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = K() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ye(o);
    }
  while (o = z());
  return r;
}, dn = function(r, n) {
  return Xr(ln(Zr(r), n));
}, Fr = /* @__PURE__ */ new WeakMap(), pn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Fr.get(a)) && !o) {
      Fr.set(r, !0);
      for (var i = [], u = dn(n, i), l = a.props, p = 0, h = 0; p < u.length; p++)
        for (var d = 0; d < l.length; d++, h++)
          r.props[h] = i[p] ? u[p].replace(/&\f/g, l[d]) : l[d] + " " + u[p];
    }
  }
}, vn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, hn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", mn = function(r) {
  return r.type === "comm" && r.children.indexOf(hn) > -1;
}, yn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var u = !!n.parent, l = u ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var h = l[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (mn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Qr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, En = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!Qr(n[a]))
      return !0;
  return !1;
}, Mr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, gn = function(r, n, a) {
  Qr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Mr(r)) : En(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Mr(r)));
};
function et(e, r) {
  switch (Jt(e, r)) {
    case 5103:
      return w + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return w + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return w + e + Ve + e + Y + e + e;
    case 6828:
    case 4268:
      return w + e + Y + e + e;
    case 6165:
      return w + e + Y + "flex-" + e + e;
    case 5187:
      return w + e + x(e, /(\w+).+(:[^]+)/, w + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return w + e + Y + "flex-item-" + x(e, /flex-|-self/, "") + e;
    case 4675:
      return w + e + Y + "flex-line-pack" + x(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return w + e + Y + x(e, "shrink", "negative") + e;
    case 5292:
      return w + e + Y + x(e, "basis", "preferred-size") + e;
    case 6060:
      return w + "box-" + x(e, "-grow", "") + w + e + Y + x(e, "grow", "positive") + e;
    case 4554:
      return w + x(e, /([^-])(transform)/g, "$1" + w + "$2") + e;
    case 6187:
      return x(x(x(e, /(zoom-|grab)/, w + "$1"), /(image-set)/, w + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return x(e, /(image-set\([^]*)/, w + "$1$`$1");
    case 4968:
      return x(x(e, /(.+:)(flex-)?(.*)/, w + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + w + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return x(e, /(.+)-inline(.+)/, w + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (L(e, r + 1)) {
          case 109:
            if (L(e, r + 4) !== 45)
              break;
          case 102:
            return x(e, /(.+:)(.+)-([^]+)/, "$1" + w + "$2-$3$1" + Ve + (L(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~or(e, "stretch") ? et(x(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (L(e, r + 1) !== 115)
        break;
    case 6444:
      switch (L(e, J(e) - 3 - (~or(e, "!important") && 10))) {
        case 107:
          return x(e, ":", ":" + w) + e;
        case 101:
          return x(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + w + (L(e, 14) === 45 ? "inline-" : "") + "box$3$1" + w + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (L(e, r + 11)) {
        case 114:
          return w + e + Y + x(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return w + e + Y + x(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return w + e + Y + x(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return w + e + Y + e + e;
  }
  return e;
}
var bn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case pr:
        r.return = et(r.value, r.length);
        break;
      case Jr:
        return ie([Ee(r, {
          value: x(r.value, "@", "@" + w)
        })], o);
      case dr:
        if (r.length)
          return Ht(r.props, function(i) {
            switch (Kt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ie([Ee(r, {
                  props: [x(i, /:(read-\w+)/, ":" + Ve + "$1")]
                })], o);
              case "::placeholder":
                return ie([Ee(r, {
                  props: [x(i, /:(plac\w+)/, ":" + w + "input-$1")]
                }), Ee(r, {
                  props: [x(i, /:(plac\w+)/, ":" + Ve + "$1")]
                }), Ee(r, {
                  props: [x(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, _n = [bn], Sn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(E) {
      var D = E.getAttribute("data-emotion");
      D.indexOf(" ") !== -1 && (document.head.appendChild(E), E.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || _n;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, u, l = [];
  u = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(E) {
      for (var D = E.getAttribute("data-emotion").split(" "), S = 1; S < D.length; S++)
        i[D[S]] = !0;
      l.push(E);
    }
  );
  var p, h = [pn, vn];
  process.env.NODE_ENV !== "production" && h.push(yn({
    get compat() {
      return C.compat;
    }
  }), gn);
  {
    var d, y = [on, process.env.NODE_ENV !== "production" ? function(E) {
      E.root || (E.return ? d.insert(E.return) : E.value && E.type !== lr && d.insert(E.value + "{}"));
    } : cn(function(E) {
      d.insert(E);
    })], N = sn(h.concat(o, y)), A = function(D) {
      return ie(nn(D), N);
    };
    p = function(D, S, g, $) {
      d = g, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          g.insert(c + S.map);
        }
      }), A(D ? D + "{" + S.styles + "}" : S.styles), $ && (C.inserted[S.name] = !0);
    };
  }
  var C = {
    key: n,
    sheet: new Ut({
      key: n,
      container: u,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return C.sheet.hydrate(l), C;
}, sr = { exports: {} }, T = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function Rn() {
  if (jr)
    return T;
  jr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function $(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case C:
                case A:
                case u:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function I(c) {
    return $(c) === h;
  }
  return T.AsyncMode = p, T.ConcurrentMode = h, T.ContextConsumer = l, T.ContextProvider = u, T.Element = r, T.ForwardRef = d, T.Fragment = a, T.Lazy = C, T.Memo = A, T.Portal = n, T.Profiler = i, T.StrictMode = o, T.Suspense = y, T.isAsyncMode = function(c) {
    return I(c) || $(c) === p;
  }, T.isConcurrentMode = I, T.isContextConsumer = function(c) {
    return $(c) === l;
  }, T.isContextProvider = function(c) {
    return $(c) === u;
  }, T.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, T.isForwardRef = function(c) {
    return $(c) === d;
  }, T.isFragment = function(c) {
    return $(c) === a;
  }, T.isLazy = function(c) {
    return $(c) === C;
  }, T.isMemo = function(c) {
    return $(c) === A;
  }, T.isPortal = function(c) {
    return $(c) === n;
  }, T.isProfiler = function(c) {
    return $(c) === i;
  }, T.isStrictMode = function(c) {
    return $(c) === o;
  }, T.isSuspense = function(c) {
    return $(c) === y;
  }, T.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === y || c === N || typeof c == "object" && c !== null && (c.$$typeof === C || c.$$typeof === A || c.$$typeof === u || c.$$typeof === l || c.$$typeof === d || c.$$typeof === D || c.$$typeof === S || c.$$typeof === g || c.$$typeof === E);
  }, T.typeOf = $, T;
}
var O = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function wn() {
  return Vr || (Vr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function $(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === N || typeof v == "object" && v !== null && (v.$$typeof === C || v.$$typeof === A || v.$$typeof === u || v.$$typeof === l || v.$$typeof === d || v.$$typeof === D || v.$$typeof === S || v.$$typeof === g || v.$$typeof === E);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var ve = v.$$typeof;
        switch (ve) {
          case r:
            var ne = v.type;
            switch (ne) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case y:
                return ne;
              default:
                var ee = ne && ne.$$typeof;
                switch (ee) {
                  case l:
                  case d:
                  case C:
                  case A:
                  case u:
                    return ee;
                  default:
                    return ve;
                }
            }
          case n:
            return ve;
        }
      }
    }
    var c = p, V = h, P = l, qe = u, we = r, Be = d, Ge = a, xe = C, B = A, H = n, Q = i, Ce = o, Te = y, fe = !1;
    function Oe(v) {
      return fe || (fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ue(v) || I(v) === p;
    }
    function ue(v) {
      return I(v) === h;
    }
    function Pe(v) {
      return I(v) === l;
    }
    function Ne(v) {
      return I(v) === u;
    }
    function Ae(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Je(v) {
      return I(v) === d;
    }
    function Ke(v) {
      return I(v) === a;
    }
    function le(v) {
      return I(v) === C;
    }
    function de(v) {
      return I(v) === A;
    }
    function re(v) {
      return I(v) === n;
    }
    function pe(v) {
      return I(v) === i;
    }
    function te(v) {
      return I(v) === o;
    }
    function He(v) {
      return I(v) === y;
    }
    O.AsyncMode = c, O.ConcurrentMode = V, O.ContextConsumer = P, O.ContextProvider = qe, O.Element = we, O.ForwardRef = Be, O.Fragment = Ge, O.Lazy = xe, O.Memo = B, O.Portal = H, O.Profiler = Q, O.StrictMode = Ce, O.Suspense = Te, O.isAsyncMode = Oe, O.isConcurrentMode = ue, O.isContextConsumer = Pe, O.isContextProvider = Ne, O.isElement = Ae, O.isForwardRef = Je, O.isFragment = Ke, O.isLazy = le, O.isMemo = de, O.isPortal = re, O.isProfiler = pe, O.isStrictMode = te, O.isSuspense = He, O.isValidElementType = $, O.typeOf = I;
  }()), O;
}
process.env.NODE_ENV === "production" ? sr.exports = Rn() : sr.exports = wn();
var xn = sr.exports, rt = xn, Cn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Tn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, tt = {};
tt[rt.ForwardRef] = Cn;
tt[rt.Memo] = Tn;
var On = !0;
function Pn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var nt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  On === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Nn = function(r, n, a) {
  nt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function An(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var $n = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Lr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, kn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", In = /[A-Z]|^ms/g, at = /_EMO_([^_]+?)_([^]*?)_EMO_/g, hr = function(r) {
  return r.charCodeAt(1) === 45;
}, Yr = function(r) {
  return r != null && typeof r != "boolean";
}, tr = /* @__PURE__ */ fn(function(e) {
  return hr(e) ? e : e.replace(In, "-$&").toLowerCase();
}), Le = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(at, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return $n[r] !== 1 && !hr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Dn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Fn = ["normal", "none", "initial", "inherit", "unset"], Mn = Le, jn = /^-ms-/, Vn = /-(.)/g, Wr = {};
  Le = function(r, n) {
    if (r === "content" && (typeof n != "string" || Fn.indexOf(n) === -1 && !Dn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Mn(r, n);
    return a !== "" && !hr(r) && r.indexOf("-") !== -1 && Wr[r] === void 0 && (Wr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(jn, "ms-").replace(Vn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ot = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ot);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Ln(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, u = n(e);
        return G = i, Se(e, r, u);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(at, function(d, y, N) {
          var A = "animation" + l.length;
          return l.push("const " + A + " = keyframes`" + N.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Ln(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Se(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var u = n[i];
      if (typeof u != "object")
        r != null && r[u] !== void 0 ? a += i + "{" + r[u] + "}" : Yr(u) && (a += tr(i) + ":" + Le(i, u) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ot);
        if (Array.isArray(u) && typeof u[0] == "string" && (r == null || r[u[0]] === void 0))
          for (var l = 0; l < u.length; l++)
            Yr(u[l]) && (a += tr(i) + ":" + Le(i, u[l]) + ";");
        else {
          var p = Se(e, r, u);
          switch (i) {
            case "animation":
            case "animationName": {
              a += tr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(kn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Ur = /label:\s*([^\s;\n{]+)\s*(;|$)/g, it;
process.env.NODE_ENV !== "production" && (it = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, zr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var u = r[0];
  u == null || u.raw === void 0 ? (o = !1, i += Se(a, n, u)) : (process.env.NODE_ENV !== "production" && u[0] === void 0 && console.error(Lr), i += u[0]);
  for (var l = 1; l < r.length; l++)
    i += Se(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && u[l] === void 0 && console.error(Lr), i += u[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(it, function(N) {
    return p = N, "";
  })), Ur.lastIndex = 0;
  for (var h = "", d; (d = Ur.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = An(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, Yn = function(r) {
  return r();
}, Wn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Un = Wn || Yn, ze = {}.hasOwnProperty, mr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Sn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (mr.displayName = "EmotionCacheContext");
mr.Provider;
var zn = function(r) {
  return /* @__PURE__ */ At(function(n, a) {
    var o = Gr(mr);
    return r(n, o, a);
  });
}, st = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (st.displayName = "EmotionThemeContext");
var qr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, qn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return qr(n[1]);
}, Bn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Gn = function(r) {
  return r.replace(/\$/g, "-");
}, Jn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = qn(n[a]);
      if (o) {
        if (Bn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Gn(o);
      }
    }
}, cr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", fr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ct = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    ze.call(n, o) && (a[o] = n[o]);
  if (a[cr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Jn(new Error().stack);
    i && (a[fr] = i);
  }
  return a;
}, Kn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return nt(n, a, o), Un(function() {
    return Nn(n, a, o);
  }), null;
}, ft = /* @__PURE__ */ zn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[cr], i = [a], u = "";
  typeof e.className == "string" ? u = Pn(r.registered, i, e.className) : e.className != null && (u = e.className + " ");
  var l = zr(i, void 0, X.useContext(st));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[fr];
    p && (l = zr([l, "label:" + p + ";"]));
  }
  u += r.key + "-" + l.name;
  var h = {};
  for (var d in e)
    ze.call(e, d) && d !== "css" && d !== cr && (process.env.NODE_ENV === "production" || d !== fr) && (h[d] = e[d]);
  return h.ref = n, h.className = u, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Kn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (ft.displayName = "EmotionCssPropInternal");
var ut = ft, Hn = ge.Fragment;
function De(e, r, n) {
  return ze.call(r, "css") ? ge.jsx(ut, ct(e, r), n) : ge.jsx(e, r, n);
}
function nr(e, r, n) {
  return ze.call(r, "css") ? ge.jsxs(ut, ct(e, r), n) : ge.jsxs(e, r, n);
}
const Zn = ur`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
`;
function Xn(e) {
  const r = e == "white" ? Nr(`--${Ar}-grayBlue-02`) : Nr(`--${Ar}-white-02`);
  return ur`
    color: ${r};
  `;
}
const Qn = ur`
  margin-top: 4px;
  align-self: end;
`, ea = (e) => {
  var E;
  const {
    title: r,
    content: n,
    colorScheme: a = "white",
    popupVisible: o,
    onVisibleChange: i,
    trigger: u = "click",
    hasCloseIcon: l = !0,
    // must be false
    closeOnClick: p = !1,
    defaultPopupVisible: h,
    ...d
  } = e, y = Gr(Ft), N = ((E = y == null ? void 0 : y.locale) == null ? void 0 : E.popover) ?? Mt.popover, [A, C] = $t(h ?? !1);
  return De(kt, { colorScheme: a, trigger: u, popupVisible: o ?? A, closeOnClick: p, withoutPadding: !0, onVisibleChange: (D) => {
    i != null && i(D), o == null && C(D);
  }, content: nr("div", { css: Zn, children: [nr(It, { children: [r && nr(Hn, { children: [De(Dt, { css: Xn(a), colorScheme: a == "white" ? "gray" : "white", title: r, ellipsis: !1, level: "h6", children: r }), De("div", { style: { height: "4px" } })] }), n] }), l && De(jt, { colorScheme: a == "white" ? "blue" : "white", css: Qn, onClick: () => {
    o == null && C(!1), i != null && i(!1);
  }, children: N.close })] }), ...d, children: e.children });
};
ea.displayName = "Popover";
export {
  ea as Popover
};
//# sourceMappingURL=index.js.map
